import { render, staticRenderFns } from "./KeyboardShortcuts.vue?vue&type=template&id=d0115cda&scoped=true"
import script from "./KeyboardShortcuts.vue?vue&type=script&lang=js"
export * from "./KeyboardShortcuts.vue?vue&type=script&lang=js"
import style0 from "./KeyboardShortcuts.vue?vue&type=style&index=0&id=d0115cda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0115cda",
  null
  
)

export default component.exports